<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-2"><a id="page_xi"><strong>PRINCIPAL ABBREVIATIONS</strong></a></h1><a id="page_xi">
<table>
<tbody><tr>
<td class="wid15"><p class="abbr"><em>ADAJ</em></p></td>
<td class="wid80"><p class="abbr"><em>Annual of the Department of Antiquities of Jordan</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>AJSL</em></p></td>
<td class="wid80"><p class="abbr"><em>American Journal of Semitic Languages</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr">Akk.</p></td>
<td class="wid80"><p class="abbr">Akkadian</p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>ANET(S)</em></p></td>
<td class="wid80"><p class="abbr">J. B. Pritchard, ed., <em>Ancient Near Eastern Texts</em> (<sup>2</sup>1955, <sup>3</sup>1969); Supplement (1969)</p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr">Arab.</p></td>
<td class="wid80"><p class="abbr">Arabic</p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>ARAB</em></p></td>
<td class="wid80"><p class="abbr">D. D. Luckenbill, <em>Ancient Records of Assyria and Babylonia</em>, 2 vols. (1926–27)</p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>ARM</em></p></td>
<td class="wid80"><p class="abbr"><em>Archives Royales de Mari</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>ATD</em></p></td>
<td class="wid80"><p class="abbr"><em>Das Alte Testament Deutsch</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr">AV</p></td>
<td class="wid80"><p class="abbr">Authorised (King James) Version of the Bible</p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>BA</em></p></td>
<td class="wid80"><p class="abbr"><em>Biblical Archaeologist</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>BASOR</em></p></td>
<td class="wid80"><p class="abbr"><em>Bulletin of the American Schools of Oriental Research</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>BHS</em></p></td>
<td class="wid80"><p class="abbr"><em>Biblia Hebraica Stuttgartensia</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>BJRL</em></p></td>
<td class="wid80"><p class="abbr"><em>Bulletin of the John Rylands Library</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>CAD</em></p></td>
<td class="wid80"><p class="abbr"><em>The Assyrian Dictionary of the Oriental Institute of the University of Chicago</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>CBQ</em></p></td>
<td class="wid80"><p class="abbr"><em>Catholic Biblical Quarterly</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>EQ</em></p></td>
<td class="wid80"><p class="abbr"><em>Evangelical Quarterly</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr">E.T.</p></td>
<td class="wid80"><p class="abbr">English Translation</p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr">FRLANT</p></td>
<td class="wid80"><p class="abbr">Forschungen zur Religion und Literatur des Alten und Neuen Testaments</p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr">GNB</p></td>
<td class="wid80"><p class="abbr">Good News Bible</p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr">HAT</p></td>
<td class="wid80"><p class="abbr">Handbuch zum Alten Testament</p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>HUCA</em></p></td>
<td class="wid80"><p class="abbr"><em>Hebrew Union College Annual</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>IB</em></p></td>
<td class="wid80"><p class="abbr"><em>Interpreter’s Bible</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr">ICC</p></td>
<td class="wid80"><p class="abbr">International Critical Commentary</p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>IDB</em></p></td>
<td class="wid80"><p class="abbr"><em>Interpreter’s Dictionary of the Bible</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>IEJ</em></p></td>
<td class="wid80"><p class="abbr"><em>Israel Exploration Journal</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>JA</em></p></td>
<td class="wid80"><p class="abbr"><em>Journal Asiatique</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>JAOS</em></p></td>
<td class="wid80"><p class="abbr"><em>Journal of the American Oriental Society</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>JBC</em></p></td>
<td class="wid80"><p class="abbr"><em>The Jerome Bible Commentary</em> (1969)</p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><a id="page_xii"><em>JBL</em></a></p></td>
<td class="wid80"><p class="abbr"><em>Journal of Biblical Literature</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>JCS</em></p></td>
<td class="wid80"><p class="abbr"><em>Journal of Cuneiform Studies</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>JNES</em></p></td>
<td class="wid80"><p class="abbr"><em>Journal of Near Eastern Studies</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>JPOS</em></p></td>
<td class="wid80"><p class="abbr"><em>Journal of the Palestine Oriental Society</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>JQR</em></p></td>
<td class="wid80"><p class="abbr"><em>Jewish Quarterly Review</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>JSS</em></p></td>
<td class="wid80"><p class="abbr"><em>Journal of Semitic Studies</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>JTS</em></p></td>
<td class="wid80"><p class="abbr"><em>Journal of Theological Studies</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr">KB</p></td>
<td class="wid80"><p class="abbr">Koehler and Baumgartner, <em>Lexicon in Veteris Testamenti Libros</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr">LXX</p></td>
<td class="wid80"><p class="abbr">Septuagint</p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr">MT</p></td>
<td class="wid80"><p class="abbr">Masoretic Text</p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>NBD</em></p></td>
<td class="wid80"><p class="abbr">J. D. Douglas, ed., <em>The New Bible Dictionary</em> (1962)</p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr">NEB</p></td>
<td class="wid80"><p class="abbr">The New English Bible</p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr">NICOT</p></td>
<td class="wid80"><p class="abbr">New International Commentary on the Old Testament</p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>OTS</em></p></td>
<td class="wid80"><p class="abbr"><em>Oudtestamentische Studiën</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>PEQ</em></p></td>
<td class="wid80"><p class="abbr"><em>Palestine Exploration Quarterly</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>RB</em></p></td>
<td class="wid80"><p class="abbr"><em>Revue Biblique</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>RHPR</em></p></td>
<td class="wid80"><p class="abbr"><em>Revue d’Histoire et de Philosophic Religieuses</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr">RSV</p></td>
<td class="wid80"><p class="abbr">Revised Standard Version of the Bible</p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr">RV</p></td>
<td class="wid80"><p class="abbr">Revised Version of the Bible</p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr">SVT</p></td>
<td class="wid80"><p class="abbr">Supplements to <em>Vetus Testamentum</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr">Syr.</p></td>
<td class="wid80"><p class="abbr">Syriac</p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>UF</em></p></td>
<td class="wid80"><p class="abbr"><em>Ugarit-Forschungen</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr">Ugar.</p></td>
<td class="wid80"><p class="abbr">Ugaritic</p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>UT</em></p></td>
<td class="wid80"><p class="abbr">C. H. Gordon, <em>Ugaritic Textbook</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>VT</em></p></td>
<td class="wid80"><p class="abbr"><em>Vetus Testamentum</em></p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr">Vulg.</p></td>
<td class="wid80"><p class="abbr">Vulgate</p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr">WMANT</p></td>
<td class="wid80"><p class="abbr">Wissenschaftliche Monographien zum Alten und Neuen Testament</p></td>
</tr>
<tr>
<td class="wid15"><p class="abbr"><em>ZAW</em></p></td>
<td class="wid80"><p class="abbr"><em>Zeitschrift für die alttestamentliche Wissenschaft</em></p></td>
</tr>
</tbody></table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008_Abbreviations.vue?af360d32